module.exports = __webpack_public_path__ + "img/empty-state-contacts.5620ec84.png";